export enum BulkAction {
  PAYMENT_REQUEST = <any>'PAYMENT_REQUEST',
  PAID_DIRECT = <any>'PAID_DIRECT',
  CANCELLED = <any>'CANCELLED'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/bulk-action.ts